import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

import router from "@/router";
// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useQuotationsList() {
  // Use toast
  const toast = useToast();

  const refQuotationListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "id", label: "編號", class: 'sticky-column', sortable: true },
    { key: "quotation_date", class: 'sticky-column', label: "發單日期", sortable: true },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "show_details", label: "項目摘要" },
    { key: "stamp", label: "公司印章" },
    { key: "customer.name_cn", label: "單據抬頭" },
    { key: "quotation_type_id", label: "類別", sortable: true },
    { key: "project_name", label: "項目名稱", sortable: true },
    { key: "address", label: "施工地址", sortable: true },
    { key: "total_amount", label: "總價", formatter: formatCurrency },
    
    /* { key: "name_en", label: "單據抬頭" }, */
    { key: "mobile", label: "聯絡電話" },
    { key: "email", label: "電郵地址"},
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("quotation_date");
  const isSortDirDesc = ref(true);

  const quotationsList = ref(null);

  const filter_quotation_type_id = ref(null);
  const filter_project_id = ref(null);
  const filter_customer_id = ref(null);
  const filter_product_id = ref(null);
  const filter_stamp_id = ref(null);
  const filter_quotating = ref(0);

  const dataMeta = computed(() => {
    const localItemsCount = refQuotationListTable.value
      ? refQuotationListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refQuotationListTable.value.refresh();
  };

  watch(
    [
      currentPage, perPage, searchQuery, 
      filter_quotation_type_id, filter_project_id, filter_customer_id, 
      filter_product_id, filter_stamp_id, filter_quotating
    ],
    () => {
      refetchData();
    }
  );

  let init = true
  const fetchQuotations = (ctx, callback) => {
   
    if(router.currentRoute.params.quotating && init){
      filter_quotating.value = router.currentRoute.params.quotating
      init = false
    }
    store
      .dispatch("quotation/fetchQuotations", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        quotation_type_id: filter_quotation_type_id.value,
        project_id: filter_project_id.value,
        customer_id: filter_customer_id.value,
        product_id: filter_product_id.value,
        quotating: filter_quotating.value,
      })
      .then((response) => {
        const { quotations, total } = response.data;
        callback(quotations);
        totalRow.value = total;
        quotationsList.value = quotations
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const quotationTypeOptions = ref([]);
  const customerOptions = ref([]);
  const projectOptions = ref([]);
  const productOptions = ref([]);
  const workerOptions = ref([]);
  const productCategoriesOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        quotation_types: true,
        projects: true,
        customers: true,
        products: true,
        workers: true,
        product_categories: true,
      })
      .then((response) => {
        quotationTypeOptions.value = response.data.quotation_types;
        productCategoriesOptions.value = response.data.product_categories;
        projectOptions.value = response.data.projects;
        customerOptions.value = response.data.customers;
        productOptions.value = response.data.products;
        workerOptions.value = response.data.workers;

      });
  };



  onMounted(() => {
    refetchOption();
  });

  return {
    fetchQuotations,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    quotationsList,
    refQuotationListTable,
    ability,
    refetchData,
    filter_quotation_type_id,
    filter_project_id,
    filter_customer_id,
    filter_product_id,
    filter_stamp_id,
    filter_quotating,
    quotationTypeOptions,
    customerOptions,
    projectOptions,
    productOptions,
    workerOptions,
    productCategoriesOptions,
  };
}
